<dw-ui-dialog-box [title]="dialogBoxTitle" [saveDisabled]="!canSave || isSaving" (saveFn)="save()">
  <div>
    <document-eligible-customer-orders-grid
      [orders]="eligibleOrders()"
      [preSelectedOrderId]="customerSalePurchaseId"
      (selectionChange)="onOrderSelectionChange($event)"
    >
    </document-eligible-customer-orders-grid>
  </div>

  <!-- Nothing to prepare: the grid above says so on its own, an empty line editor adds nothing. -->
  @if (hasEligibleOrders()) {
    <div class="mt-5">
      <document-customer-preparation-lines-editor
        [lines]="orderLinesToPrepare"
      ></document-customer-preparation-lines-editor>
    </div>
  }
</dw-ui-dialog-box>
